"use strict";
exports.__esModule = true;
var cookie_1 = require("./storage/cookie");
var local_storage_1 = require("./storage/local_storage");
var GuestiaStorage = /** @class */ (function () {
    function GuestiaStorage(type, schema) {
        this.providers = {
            cookie: cookie_1["default"],
            localStorage: local_storage_1["default"]
        };
        switch (type) {
            case 'cookie':
                this.defaultStorage = cookie_1["default"];
                break;
            case 'localStorage':
                this.defaultStorage = local_storage_1["default"];
                break;
            default:
                throw new Error("Not supported storage " + type);
        }
        this.schema = schema;
    }
    GuestiaStorage.prototype.get = function (key) {
        return this.getStorage(key).get(key);
    };
    GuestiaStorage.prototype.set = function (key, value) {
        if (typeof value !== 'undefined') {
            var schemaParams = this.schema[key] || {};
            this.getStorage(key).set(key, value, schemaParams);
        }
    };
    GuestiaStorage.prototype.remove = function (key) {
        this.getStorage(key).remove(key);
    };
    GuestiaStorage.prototype.keys = function () {
        return Object.keys(this.schema);
    };
    GuestiaStorage.prototype.getStorage = function (key) {
        var schemaField = this.schema[key] || { storageProvider: null };
        return this.providers[schemaField.storageProvider] || this.defaultStorage;
    };
    return GuestiaStorage;
}());
exports["default"] = GuestiaStorage;
